Ext.define('SA.model.Attribute', {
    constructor(params) {
        this.id = params.id;
        this.datasetSeries = params.datasetSeries;
        this.name = params.name;
        this.label = params.label;
        this.type = params.type;
        this.indent = params.indent;
        this.censusReleaseYear = params.censusReleaseYear;
        this.valueFormatter = params.valueFormatter;
        this.hasPolygonClass = params.hasPolygonClass;
    },

    formatValue(value) {
        return this.getValueFormatter()(value);
    },

    getId() {
        return this.id;
    },

    getIndent() {
        return this.indent;
    },

    getLabel() {
        return this.label;
    },

    getName() {
        return this.name;
    },

    getValueFormatter() {
        return this.valueFormatter;
    },

    hasDatasetSeries(datasetSeries) {
        return this.datasetSeries === datasetSeries;
    },

    hasId(id) {
        return this.getId() === id;
    },

    hasCensusReleaseYear(censusReleaseYear) {
        return this.censusReleaseYear === censusReleaseYear;
    },

    hasPercentType() {
        return this.type === 'percent';
    },

    isPolygonAttribute() {
        return this.hasPolygonClass;
    }
});